import { CobranzasAxios, COMPANY } from './config'

export const postProducts = async (data) => {
  const res = await CobranzasAxios.post(`/product/${COMPANY}`, data)
  return res.data
}

export const importProducts = async (data) => {
  const res = await CobranzasAxios.post(`/product/import/${COMPANY}`, data)
  return res.data
}

export const getProducts = async () => {
  const res = await CobranzasAxios.get(`/product/${COMPANY}`)
  return res.data
}

export const putProducts = async (data, id) => {
  const res = await CobranzasAxios.put(`/product/${id}`, data)
  return res.data
}
